'use strict';

let ShoppingListService = require('./ShoppingListService');

module.exports = function(param){
    // Adding support to use individual module standalone
    if(typeof param !== "object"){
        param = {};
    }
    // providing option to inject Custom EventBus
    if(param && typeof param._EventBus !== "object"){
        param._EventBus = require('../core/EventBus');
    }
    return new ShoppingListService(param);
};


// WEBPACK FOOTER //
// ./src/shoppingList/index.js